import { useCheckoutStore } from "@/store/checkout";
import { usePanierStore } from "@/store/panier";

export const pageCommanderConfirmationErrorProps = () => ({
  statut: {
    type: String,
    required: true
  }
})

export const usePageCommanderConfirmationError = () => {
  const checkoutStore = useCheckoutStore();
  const panierStore = usePanierStore();

  const { typePanier } = storeToRefs(checkoutStore);

  const { setStepValue, setTypePanier } = checkoutStore;
  const { setPopinPanierToListeVisible } = panierStore;

  const setPopinPanierToListe = () => {
    setPopinPanierToListeVisible(true);
  }

  const created = () => {
    setStepValue(3);
    setTypePanier(typePanier.value);
  }

  return {
    typePanier,
    setPopinPanierToListe,
    created
  }
}